module.exports = __webpack_public_path__ + "img/2024-4.957e0528.jpg";